import { useEffect, useRef, useState } from "react";

// interface SmartPollingOptions {
//   inactivityTimeout?: number;
// }
interface SmartPollingOptions {
  inactivityTimeout?: number;
  enabled?: boolean;
}

export function SmartPolling(
  fetchFn: () => Promise<void>,
  interval: number,
  options: SmartPollingOptions = {}
) {
  const { inactivityTimeout = 5 * 60 * 1000, enabled = true } = options;
  // const { inactivityTimeout = 5 * 60 * 1000 } = options;

  const [isActive, setIsActive] = useState(true);
  const [isTabVisible, setIsTabVisible] = useState(true);

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  //  Always keep latest fetchFn
  const fetchRef = useRef(fetchFn);

  useEffect(() => {
    fetchRef.current = fetchFn;
  }, [fetchFn]);

  // Activity detection
  useEffect(() => {
    const resetInactivityTimer = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setIsActive(false), inactivityTimeout);
      setIsActive(true);
    };

    const activityEvents = ["mousemove", "keydown", "scroll", "click"];

    activityEvents.forEach(event =>
      window.addEventListener(event, resetInactivityTimer)
    );

    resetInactivityTimer();

    return () => {
      activityEvents.forEach(event =>
        window.removeEventListener(event, resetInactivityTimer)
      );
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [inactivityTimeout]);

  // Tab visibility
  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabVisible(!document.hidden);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  // Polling
  // useEffect(() => {
  //   const shouldPoll = isActive && isTabVisible;
  useEffect(() => {
    if (!enabled) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }
  
    const shouldPoll = isActive && isTabVisible;

    if (shouldPoll) {
      fetchRef.current(); //  always latest version

      if (intervalRef.current) clearInterval(intervalRef.current);

      intervalRef.current = setInterval(() => {
        fetchRef.current();
      }, interval);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isActive, isTabVisible, interval, enabled]);
}
